import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { UserAuthService } from 'src/app/auth/userAuth.service';
import { LoginService } from 'src/app/login.service';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TablerIconsModule,
    TranslateModule
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {
  changepasswordForm: FormGroup;
  hideCurrentPassword: boolean = true;
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  isLoading: boolean;
  @Input() isForceChange: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _userDetail: UserAuthService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private translate: TranslateService,
    private _loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.changepasswordForm = this._formBuilder.group({
      currentpassword: ['', [Validators.required]],
      newpassword: ['', [Validators.required]],
    })
  }

  changePassword() {
    if (this.changepasswordForm.invalid) {
      return;
    }
    const password = this.changepasswordForm.getRawValue();
    this.isLoading = true;
    this._userDetail.changePassword(password)
      .pipe(
        finalize(() => {
          // Re-enable the form
          this.changepasswordForm.enable();
          this._changeDetectorRef.markForCheck();
        })
      )
      .subscribe(
        (response) => {
          if (response.isSuccess) {
            if (this.isForceChange) {
              this.toastr.success(this.translate.instant('CHANGE_PASSWORD'));
              this._loginService.signOut().subscribe();
            } else {
              this.toastr.success(this.translate.instant('CHANGE_PASSWORD'));
            }
          }
          else {
            this.toastr.error("Fail to Chanage password");
          }

          // Reset the form
          this.changepasswordForm.reset();
          this._changeDetectorRef.markForCheck();
          this.isLoading = false;
        },
        (error) => {
          this.toastr.error(error?.error?.message || error?.error?.errors?.join("\n"));

          // Reset the form
          this.changepasswordForm.reset();
          this._changeDetectorRef.markForCheck();
          this.isLoading = false;
        }
      );
  }

}
